import { useState } from "react";
import { json } from "stream/consumers";
import { CSVLink, CSVDownload } from "react-csv";
import { MainConfig } from "../configs/mainConfig";
import { useNavigate } from "react-router-dom";

export const DataExporter = () =>{
    let navigate = useNavigate();
    const [files, setFiles] = useState("");

    const [dateValue, setDateValue] = useState(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [showDownloadButton, setShowDownloadButton] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const [csvReport, setCsvReport] = useState<any>()


    const handleDateUpdate = (e) => {
        e.target.classList.remove("invalid");
        setDateValue(e.target.value);
    }
    const redirectHome = (e) => {
        navigate("/")
    }
    

    const handleExportButtonClick = () => {
        let dateInput : HTMLInputElement | null = document.getElementById("dateInput") as HTMLInputElement;
        if(dateValue == null || !dateInput.checkValidity()){
            dateInput.classList.add("invalid");
            return;
        }
        else{
            dateInput.classList.remove("invalid");
        }

        setLoading(true);

        let date = dateValue + "T00:00:00"
        let urlAPI = `${MainConfig.backendEndpoint}/api/forms/FormData/${date}`;
        fetch(`${MainConfig.backendEndpoint}/connect/token`, {
            method: 'POST',
            body: 'grant_type=client_credentials&client_id=' + MainConfig.apiKey + '&client_secret=' + MainConfig.apiSecret + '&scope: K2Forms',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (resp) {

            // Return the response as JSON
            return resp.json();
        
        }).then(function (data) {
        
            // Log the API data
            console.log('token', data);
            return fetch(urlAPI, {
                headers: {
                    'Authorization': data.token_type + ' ' + data.access_token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        
        }).then(function (resp) {

            // Return the API response as JSON
            return resp.json();
        
        }).then(function (data) {
        
            // Log the pet data
            console.log('file', data);
            processingJson(data);
            setLoading(false);
            setShowDownloadButton(true)
            setError(false)
        }).catch(function (err) {
            setLoading(false);
            setShowDownloadButton(false);
            setError(true)
            // Log any errors
            console.log('something went wrong', err);
        
        });
    }

    const handleJsonFile = e => {
        if(e){
            const fileReader = new FileReader();
            fileReader.readAsText(e.target.files[0], "UTF-8");
            fileReader.onload = e => {
                if(e.target){
                    console.log("e.target.result", e.target.result);
                    setFiles(e.target.result as string);
                    let content : string = e.target.result as string;
                    processingJson(JSON.parse(content));
                }
            };
        }
      };

    const processingJson = (json : any) => {
            //Excel file   

            //Headers
            const headers = [
                { label: "User", key: "userId" },
                { label: "Date début de session", key: "dateStartSession" },
                { label: "Date fin de session", key: "dateEndSession" },
                { label: "Score Global", key: "globalScore" },

                 //Données apprenant
                { label: "Age", key: "age" },
                { label: "Sexe", key: "sex" },
                

              

                //Echange
                { label: "Réponse échange 1", key: "dialogECH1" },
                { label: "Réponse échange 2", key: "dialogECH2" },
                { label: "Réponse échange 3", key: "dialogECH3" },
                { label: "Réponse échange 4", key: "dialogECH4" },
                { label: "Réponse échange 5", key: "dialogECH5" },
                { label: "Réponse échange 6", key: "dialogECH6" },
                { label: "Réponse échange 7", key: "dialogECH7" },
                { label: "Réponse échange 8", key: "dialogECH8" },
                { label: "Réponse échange 9", key: "dialogECH9" },
                { label: "Réponse échange 10", key: "dialogECH10" },
                { label: "Réponse échange 11", key: "dialogECH11" },
                { label: "Réponse échange 12", key: "dialogECH12" },
                { label: "Réponse échange 13", key: "dialogECH13" },
                { label: "Réponse échange 14", key: "dialogECH14" },
                { label: "Réponse échange 15", key: "dialogECH15" },
                { label: "Réponse échange 16", key: "dialogECH16" },
                { label: "Réponse échange 17", key: "dialogECH17" },
                { label: "Réponse échange 18", key: "dialogECH18" },
                { label: "Réponse échange 19", key: "dialogECH19" },
                { label: "Réponse échange 20", key: "dialogECH20" },
                { label: "Réponse échange 21", key: "dialogECH21" },
                { label: "Réponse échange 22", key: "dialogECH22" },
                { label: "Réponse échange 23", key: "dialogECH23" },
                { label: "Réponse échange 24", key: "dialogECH24" },
                { label: "Réponse échange 25", key: "dialogECH25" },
                { label: "Réponse échange 26", key: "dialogECH26" },


                //Evaluation de l'outil
                { label : "Satisfaction globale", key:"Sat1"},
                { label : "Durée adaptée", key:"Sat2"},
                { label : "Contenu pédagogique satisfaisant", key:"Sat3"},
                { label : "Système ACA informe l’apprenant", key:"Sat4"},
                { label : "Langage est approprié", key:"Sat51"},
                { label : "Compréhension est aisée", key:"Sat52"},
                { label : "Voix des ACA enseignant et patiente est adaptée et réaliste", key:"Sat53"},
                { label : "Informations présentées de façon logiques", key:"Sat54"},
                { label : "Dialogue fluide et pertinent", key:"Sat55"},
                { label : "Système ACA est homogène, les réponses sont cohérentes", key:"Sat6"},
                { label : "Cheminement visible, facile et concret", key:"Sat7"},
                { label : "Mise en œuvre du système facile", key:"Sat81"},
                { label : "Souplesse d’utilisation du système est grande ", key:"Sat82"},
                { label : "Personnages sont réalistes", key:"Sat91"},
                { label : "L’aspect visuel global est satisfaisant", key:"Sat92"},
                { label : "La modalité de dialogue avec la patiente est conviviale", key:"Sat93"},
                { label : "L’intérêt persiste jusqu’à la fin ", key:"Sat94"},
                { label : "Le système ACA maintient le même contexte au long de la session", key:"Sat95"},
                { label : "Retour à la fenêtre en cours est aisé et possible", key:"Sat10"},
                { label : "Confidentialité des données", key:"Sat11"},


                //Timer
                { label: "Chronomètre conversation complète (en secondes)", key: "timer_All"},
                { label: "Chronomètre introduction (en secondes)", key: "timer_Introduction"},
                { label: "Chronomètre choix environnement (en secondes)", key: "timer_Environnement"},
                { label: "Chronomètre dialogues globaux (en secondes)", key: "timer_Dialogue"},

                { label: "Chronomètre dialogue 1 (en secondes)", key: "timer_Dialogue1"},
                { label: "Chronomètre dialogue 2 (en secondes)", key: "timer_Dialogue2"},
                { label: "Chronomètre dialogue 3 (en secondes)", key: "timer_Dialogue3"},
                { label: "Chronomètre dialogue 4 (en secondes)", key: "timer_Dialogue4"},
                { label: "Chronomètre dialogue 5 (en secondes)", key: "timer_Dialogue5"},
                { label: "Chronomètre dialogue 6 (en secondes)", key: "timer_Dialogue6"},
                { label: "Chronomètre dialogue 7 (en secondes)", key: "timer_Dialogue7"},
                { label: "Chronomètre dialogue 8 (en secondes)", key: "timer_Dialogue8"},
                { label: "Chronomètre dialogue 9 (en secondes)", key: "timer_Dialogue9"},
                { label: "Chronomètre dialogue 10 (en secondes)", key: "timer_Dialogue10"},
                { label: "Chronomètre dialogue 11 (en secondes)", key: "timer_Dialogue11"},
                { label: "Chronomètre dialogue 12 (en secondes)", key: "timer_Dialogue12"},
                { label: "Chronomètre dialogue 13 (en secondes)", key: "timer_Dialogue13"},
                { label: "Chronomètre dialogue 14 (en secondes)", key: "timer_Dialogue14"},
                { label: "Chronomètre dialogue 15 (en secondes)", key: "timer_Dialogue15"},
                { label: "Chronomètre dialogue 16 (en secondes)", key: "timer_Dialogue16"},
                { label: "Chronomètre dialogue 17 (en secondes)", key: "timer_Dialogue17"},
                { label: "Chronomètre dialogue 18 (en secondes)", key: "timer_Dialogue18"},
                { label: "Chronomètre dialogue 19 (en secondes)", key: "timer_Dialogue19"},
                { label: "Chronomètre dialogue 20 (en secondes)", key: "timer_Dialogue20"},
                { label: "Chronomètre dialogue 21 (en secondes)", key: "timer_Dialogue21"},
                { label: "Chronomètre dialogue 22 (en secondes)", key: "timer_Dialogue22"},
                { label: "Chronomètre dialogue 23 (en secondes)", key: "timer_Dialogue23"},
                { label: "Chronomètre dialogue 24 (en secondes)", key: "timer_Dialogue24"},
                { label: "Chronomètre dialogue 25 (en secondes)", key: "timer_Dialogue25"},
                { label: "Chronomètre dialogue 26 (en secondes)", key: "timer_Dialogue26"},

                { label: "Chronomètre évaluation de l'outil (en secondes)", key: "timer_EvaluationOutil"}

            ];

            //Data
            let data : Array<any> = [];

            Object.keys(json).forEach(key => {
                let jsonUserData = json[key];
                //Various data
                let userId = jsonUserData.user;
                if(!jsonUserData.AMNACA){
                    return;
                }
                
                let dateStartSession = jsonUserData.form_data.startDate;
                let dateEndSession = jsonUserData.form_data.endDate;
                
                //Calcul de la date de début selon le timer total de la conversation
                if(dateStartSession){
                    dateStartSession = new Date(dateStartSession).toLocaleString("fr")
                }
                if(dateEndSession){
                    dateEndSession = new Date(dateEndSession).toLocaleString("fr")
                }

                //Données apprenant
                let age = jsonUserData.AMNACA?.LearnerAge;
                let sex = jsonUserData.AMNACA?.LearnerSex;
                

                //Dialogue -> 25 échanges
                let dialogResponse : Array<string> = [];
                for (let i = 1; i <= 26; i++) {
                    let index = `dialogECH${i}`;
                    if(jsonUserData.AMNACA && Reflect.has(jsonUserData.AMNACA, index)){
                        dialogResponse[i] = jsonUserData.AMNACA[index];
                    }
                }

                //Dialogue -> 25 échanges
                let dialogTimer : Array<string> = [];
                for (let i = 1; i <= 26; i++) {
                    let index = `Dialogue${i}`;
                    if(jsonUserData.AMNACA && jsonUserData.AMNACA.Timers && Reflect.has(jsonUserData.AMNACA.Timers, index)){
                        jsonUserData?.AMNACA?.Timers 
                        dialogTimer[i] = jsonUserData.AMNACA.Timers[index];
                    }
                }


                //Scoring
                let globalScore = jsonUserData.form?.globalScore?.Default ?? 0;


                //Eval outils
                let Sat1 = jsonUserData.AMNACA?.Sat1;
                let Sat2 = jsonUserData.AMNACA?.Sat2;
                let Sat3 = jsonUserData.AMNACA?.Sat3;
                let Sat4 = jsonUserData.AMNACA?.Sat4;
                let Sat51 = jsonUserData.AMNACA?.Sat51;
                let Sat52 = jsonUserData.AMNACA?.Sat52;
                let Sat53 = jsonUserData.AMNACA?.Sat53;
                let Sat54 = jsonUserData.AMNACA?.Sat54;
                let Sat55 = jsonUserData.AMNACA?.Sat55;
                let Sat6 = jsonUserData.AMNACA?.Sat6;
                let Sat7 = jsonUserData.AMNACA?.Sat7;
                let Sat81 = jsonUserData.AMNACA?.Sat81;
                let Sat82 = jsonUserData.AMNACA?.Sat82;
                let Sat91 = jsonUserData.AMNACA?.Sat91;
                let Sat92 = jsonUserData.AMNACA?.Sat92;
                let Sat93 = jsonUserData.AMNACA?.Sat93;
                let Sat94 = jsonUserData.AMNACA?.Sat94;
                let Sat95 = jsonUserData.AMNACA?.Sat95;
                let Sat10 = jsonUserData.AMNACA?.Sat10;
                let Sat11 = jsonUserData.AMNACA?.Sat11;

                //Timers
                let timer_All,
                    timer_Introduction,
                    timer_Environnement,
                    timer_Dialogue,
                    timer_EvaluationOutil
                
                if(jsonUserData?.AMNACA?.Timers){
                    timer_All = jsonUserData?.AMNACA?.Timers?.Conversation
                    timer_Introduction = jsonUserData?.AMNACA?.Timers?.Introduction
                    timer_Environnement = "Choix environnement" in jsonUserData?.AMNACA?.Timers ? jsonUserData?.AMNACA?.Timers["Choix environnement"] : undefined
                    timer_Dialogue = jsonUserData?.AMNACA?.Timers?.Dialogue
                    timer_EvaluationOutil = "Evaluation outil" in jsonUserData?.AMNACA?.Timers ? jsonUserData?.AMNACA?.Timers["Evaluation outil"] : undefined
                    
                }

                //Export
                let userData = 
                    {
                        "userId" : userId,
                        "dateStartSession": dateStartSession,
                        "dateEndSession": dateEndSession,
                        "globalScore" : globalScore,

                        "age" : age,
                        "sex" : sex,
                        
                        "Sat1" : Sat1,
                        "Sat2" : Sat2,
                        "Sat3" : Sat3,
                        "Sat4" : Sat4,
                        "Sat51" : Sat51,
                        "Sat52" : Sat52,
                        "Sat53" : Sat53,
                        "Sat54" : Sat54,
                        "Sat55" : Sat55,
                        "Sat6" : Sat6,
                        "Sat7" : Sat7,
                        "Sat81" : Sat81,
                        "Sat82" : Sat82,
                        "Sat91" : Sat91,
                        "Sat92" : Sat92,
                        "Sat93" : Sat93,
                        "Sat94" : Sat94,
                        "Sat95" : Sat95,
                        "Sat10" : Sat10,
                        "Sat11" : Sat11,

                        "timer_All": timer_All,
                        "timer_Introduction": timer_Introduction,
                        "timer_Environnement": timer_Environnement,
                        "timer_Dialogue": timer_Dialogue,
                        "timer_EvaluationOutil": timer_EvaluationOutil,
                    };

                for (let i = 1; i <= 26; i++) {
                    let index = `dialogECH${i}`;
                    userData[index] = dialogResponse[i];
                }

                for (let i = 1; i <= 26; i++) {
                    let index = `timer_Dialogue${i}`;
                    userData[index] = dialogTimer[i];
                }
                data.push(userData)
            });    

        let now = new Date();
        
        let ye = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(now);
        let mo = new Intl.DateTimeFormat('fr', { month: '2-digit' }).format(now);
        let da = new Intl.DateTimeFormat('fr', { day: '2-digit' }).format(now);
        let hh = new Intl.DateTimeFormat('fr', { hour: '2-digit', hour12 : false}).format(now);
        let mm = new Intl.DateTimeFormat('fr', { minute: '2-digit' }).format(now);
        let ss = new Intl.DateTimeFormat('fr', { second: '2-digit' }).format(now);
        hh = hh.replaceAll(" h", "");
        console.log(`${da}-${mo}-${ye}`);
        const csvReport : any = {
            data: data,
            headers: headers,
            filename: `AMNACA-Export des données-${ye}-${mo}-${da}-${hh}${mm}${ss}.csv`
        };
        console.log(csvReport)
        setCsvReport(csvReport);
    }
    return (
        <main className="ExportMain">
            <div className="ExportContainer">
                <button className="returnToHome" onClick={redirectHome}>Retour à l'accueil</button>
                <h1>Exportation des données vers un fichier Excel</h1>
                
                <label>
                    <span>Date de départ :</span>
                    <input type="date" onChange={handleDateUpdate} id="dateInput"/>
                </label>
                <button onClick={handleExportButtonClick} className="btn btn-primary">Charger les données</button>

                {/* <input type="file" onChange={handleJsonFile} /> */}
                <br />
                {loading && <div className="loader"></div>}
                {
                    csvReport && showDownloadButton && 
                    <CSVLink 
                    data={csvReport.data} 
                    headers={csvReport.headers} 
                    filename={csvReport.filename} 
                    separator={";"}
                    >
                        Télécharger le rapport
                    </CSVLink>

                }
                {error && 
                    <>
                        Une erreur est survenue lors du chargement des données
                    </>
                }
            </div>
        </main>
    )
}